(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldDetailController', SegmentFieldDetailController);

    SegmentFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'SegmentField', 'ProviderSegment'];

    function SegmentFieldDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, SegmentField, ProviderSegment) {
        var vm = this;

        vm.segmentField = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:segmentFieldUpdate', function(event, result) {
            vm.segmentField = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
